// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

const OAuthRedirectUrl = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '') + '/dashboard';

export const environment = {
    production: false,
	envName: 'dev',
	systemCode: 'SYSTEM_CODE_PLACEHOLDER',
    authUrl: "AUTH_URL_PLACEHOLDER",
    OAuthRedirectUrl,
    OAuthClientId: "OAUTH_CLIENT_ID_PLACEHOLDER",
    OAuthSecret: "OAUTH_SECRET_PLACEHOLDER",
    translate: {
        defaultLanguage: "DEFAULT_LANGUAGE_PLACEHOLDER"
	},
	casBaseUrl: "CAS_BASE_URL_PLACEHOLDER",
    strictLogout: Boolean("TOKEN_STRICT_LOGOUT_PLACEHOLDER")
};
